import { z } from 'zod'
import { normalizedHexColorSchema } from '../validators/tenant.validator.js'
import { cornerRadiusSchema } from '../enums/corner-radius.enum.js'
import { fontFamilySchema } from '../enums/font-family.enum.js'

/** The tenant branding a signer or answerer page renders. */
export const brandDtoSchema = z.object({
  displayName: z.string(),
  fromName: z.string(),
  logoUrl: z.string().nullable(),
  /** Our stored copy of the logo, as a path on the API (load it from there; never from logoUrl). Null when there's none. */
  logoSrc: z.string().nullable(),
  accentColor: normalizedHexColorSchema.nullable(),
  cornerRadius: cornerRadiusSchema,
  fontFamily: fontFamilySchema,
})

export type BrandDto = z.infer<typeof brandDtoSchema>
